import $ from 'jquery';

const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-menu-trigger');
    const $mobileMenu = $('.mobile-nav');
    const activeClass = 'is-active';
    const bodyActiveClass = 'mobile-menu-is-active';

    if ($trigger.length) {
        $trigger.on('click', function () {
            $(this).closest('.s-mobile-header').find('.c-mobile-menu-trigger').toggleClass(activeClass);
            $mobileMenu.toggleClass(activeClass);
            $('body').toggleClass(bodyActiveClass);
        });
    }
};

// doc ready
$(() => {
    mobileMenuTriggerInit();
});



// WEBPACK FOOTER //
// ./src/components/mobile-header/mobile-nav-trigger/c-mobile-nav-trigger.js